import { API_ENDPOINTS } from "@/config";
import type { Address } from "@/types";
import { api } from "@/services";

interface WaitlistData {
    isRegistered: boolean;
    referrerCode: string;
    referralCode: string;
    referralCount: number;
    registrationTimestampMs: number;
}

interface ButtonData {
    totalClicks: number;
    maxClicks: number;
    lastClickRemainingSec: number;
}

export interface UserInfo {
    address: Address;
    isHuman: boolean;
    waitlistData: WaitlistData;
    buttonData: ButtonData;
}

export interface AnnouncementUser {
    address: string;
    referralCode: string;
    referralCount: number;
    referrerCode: string;
    emailRegistered: boolean;
    registrationTimestampMs: number;
}

export async function getAnnouncementUser(address: string): Promise<AnnouncementUser | null> {
    if (!address) {
        return null;
    }

    try {
        const response = await api.get(API_ENDPOINTS.ANNOUNCEMENT.USER(address));
        return response.data.data;
    } catch (_e: any) {
        console.warn("API does not have a record of this user");
        return null;
    }
}

export async function registerUser(
    address: string,
    referrer: string,
    issuedAt: string,
    signature: string,
): Promise<boolean> {
    try {
        const response = await api.post(API_ENDPOINTS.ANNOUNCEMENT.REGISTER, {
            address,
            referrer,
            issuedAt,
            signature,
        });
        return response.status >= 200 && response.status < 300;
    } catch (error) {
        console.error("Error registering user:", error);
        return false;
    }
}
